/**
 * Stub vacío que sustituye `next/dist/build/polyfills/polyfill-module`.
 *
 * Next inyecta esos polyfills (Array.at/flat/flatMap, Object.hasOwn/fromEntries,
 * String.trimStart/trimEnd…) en el bundle de cliente aunque el browserslist ya
 * sea Chrome/Edge/Firefox 111+ y Safari 16.4+, donde todas esas APIs existen.
 * Lighthouse lo marca como "JavaScript heredado" (~14 KiB).
 *
 * Solo es seguro mientras el browserslist de package.json se mantenga en el
 * baseline moderno de Next. Si se amplía a navegadores viejos, quitar el alias
 * en next.config.mjs.
 */
export {};
